<template>
  <div class="new-home-con">
    <!-- <el-carousel arrow="never" :interval="10000">
      <el-carousel-item
        v-for="(item, index) in carouselList"
        :key="index"
        :style="{ backgroundImage: 'url(' + item.img + ')' }"
      >
      </el-carousel-item>
     
    </el-carousel> -->
    <div
      class="el-carousel__item"
      :class="
        this.$route.name == 'newsIndex'
          ? 'u070db_3'
          : this.$route.name == 'dataServicesIndex'
          ? 'u070db_6'
          : 'u070db_4'
      "
    ></div>
    <div class="new-home-wrap">
      <Header></Header>
      <div class="new-home-search">
        <SearchCon></SearchCon>
        <div
          class="new-home-search-text"
          v-if="this.$route.name == 'newsIndex'"
        >
          Uncover the strategic insights behind every company headline
        </div>
        <div
          class="new-home-search-text"
          v-else-if="this.$route.name == 'dataServicesIndex'"
        >
          <div class="dataServiceIndex-search-text">
            <div class="earth-icon">
              <!-- <img :src="dsIcon7" /> -->
            </div>
            Coverage of countries
            <span class="point-num">200+</span>
            , core fields
            <span class="point-num">1,000+</span>
            , and industries
            <span class="point-num">500+</span>
          </div>
        </div>
        <div class="new-home-search-text" v-else>
          Navigate international trade with confidence by screening companies
          and products against global sanctions
        </div>
      </div>
      <!-- 底部 -->
      <!-- 数据服务 -->
      <div
        class="new-home-bottom"
        v-if="$route.name == 'dataServicesIndex'"
        :class="{
          'dataService-home-bottom': $route.name == 'dataServicesIndex',
        }"
      >
        <ul class="dataService-bottom-card">
          <li class="dataService-bottom-card-li">
            <router-link to="/dataServices/dataCleaning">
              <div class="dataService-bottom-card-in">
                <div class="dataService-bottom-card-close">
                  <div class="dataService-bottom-card-icon">
                    <img :src="dsIcon1" />
                  </div>
                  <div class="dataService-bottom-card-title">
                    Data Cleaning Services
                  </div>
                  <div class="dataService-bottom-card-text">
                    Clean, verify, and enrich corporate data at scale. Turn
                    fragmented lists into actionable intelligence.
                  </div>
                </div>
                <div class="dataService-bottom-card-open">
                  <div class="dataService-card-open-li">
                    <div class="dataService-open-title">Core Capabilities</div>
                    <ul class="dataService-open-text">
                      <li>Process and standardize bulk company data.</li>
                      <li>
                        Verify entity validity and automatically update key
                        information.
                      </li>
                      <li>
                        Refresh critical fields including registration status,
                        shareholder structure, contact details, and operational
                        insights.
                      </li>
                    </ul>
                  </div>
                  <div class="dataService-card-open-li">
                    <div class="dataService-open-title">
                      Simplified Workflow
                    </div>
                    <ul class="dataService-open-text">
                      <li>Upload your list of companies.</li>
                      <li>Our system automatically verifies each entity.</li>
                      <li>Instantly receive structured, updated data.</li>
                    </ul>
                  </div>
                </div>
                <img :src="dsIcon6" class="dataService-bottom-card-link" />
              </div>
            </router-link>
          </li>
          <li class="dataService-bottom-card-li">
            <router-link to="/dataServices/dataApi">
              <div class="dataService-bottom-card-in">
                <div class="dataService-bottom-card-close">
                  <div class="dataService-bottom-card-icon">
                    <img :src="dsIcon2" />
                  </div>
                  <div class="dataService-bottom-card-title">
                    Data API Services
                  </div>
                  <div class="dataService-bottom-card-text">
                    Access and enrich comprehensive company data in one API
                    call. A developer‑friendly, high‑performance solution for
                    seamless integration.
                  </div>
                </div>
                <div class="dataService-bottom-card-open">
                  <div class="dataService-card-open-li">
                    <div class="dataService-open-title">Key Features</div>
                    <ul class="dataService-open-text">
                      <li>
                        Batch Processing: Process multiple companies in one
                        request.
                      </li>
                      <li>
                        Entity Verification: Verify business authenticity
                        automatically.
                      </li>
                      <li>
                        Data Standardization: Get clean, analysis‑ready data.
                      </li>
                      <li>High Performance: Fast, stable responses.</li>
                      <li>
                        Flexible Integration: Fits CRM, KYC, risk assessment,
                        etc.
                      </li>
                    </ul>
                  </div>
                  <div class="dataService-card-open-li">
                    <div class="dataService-open-title">How It Works</div>
                    <ul class="dataService-open-text">
                      <li>
                        Integrate our endpoint to access real‑time corporate
                        data—registration, ownership, financials, compliance,
                        and more.
                      </li>
                    </ul>
                  </div>
                </div>
                <img :src="dsIcon6" class="dataService-bottom-card-link" />
              </div>
            </router-link>
          </li>
          <li class="dataService-bottom-card-li">
            <router-link to="/dataServices/bulkData">
              <div class="dataService-bottom-card-in">
                <div class="dataService-bottom-card-close">
                  <div class="dataService-bottom-card-icon">
                    <img :src="dsIcon3" />
                  </div>
                  <div class="dataService-bottom-card-title">
                    Bulk Data Service
                  </div>
                  <div class="dataService-bottom-card-text">
                    Build your own dataset. Select fields on-demand and receive
                    ready-to-use, structured data.
                  </div>
                </div>
                <div class="dataService-bottom-card-open">
                  <div class="dataService-card-open-li">
                    <div class="dataService-open-title">Service Highlights</div>
                    <ul class="dataService-open-text">
                      <li>
                        Custom Field Selection: Choose from a wide range of data
                        points—from basic registration to in-depth financials—to
                        create a dataset tailored to your specific project.
                      </li>
                      <li>
                        Structured Delivery: Receive your data in clean,
                        analysis-ready formats (like CSV or via database dump),
                        eliminating the need for manual cleaning and parsing.
                      </li>
                      <li>
                        On-Demand Access: Order and download the precise data
                        snapshot you need, when you need it, for maximum
                        flexibility.
                      </li>
                    </ul>
                  </div>
                </div>
                <img :src="dsIcon6" class="dataService-bottom-card-link" />
              </div>
            </router-link>
          </li>
          <li class="dataService-bottom-card-li">
            <router-link to="/dataServices/dataLibrary">
              <div class="dataService-bottom-card-in positionRight">
                <div class="dataService-bottom-card-open">
                  <div class="dataService-card-open-li">
                    <div class="dataService-open-title">Core Contents</div>
                    <ul class="dataService-open-text">
                      <li>
                        Full API Documentation: Detailed references for all
                        endpoints, parameters, and responses.
                      </li>
                      <li>
                        Product Manuals & Specifications: Complete guides for
                        service features and data models.
                      </li>
                      <li>
                        Operational Guides & Best Practices: Step-by-step
                        instructions and tutorials for implementation and
                        management.
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="dataService-bottom-card-close">
                  <div class="dataService-bottom-card-icon">
                    <img :src="dsIcon4" />
                  </div>
                  <div class="dataService-bottom-card-title">Data Library</div>
                  <div class="dataService-bottom-card-text">
                    Access the central product documentation repository. Your
                    authoritative source for technical integration and
                    compliance.
                  </div>
                </div>
                <img :src="dsIcon6" class="dataService-bottom-card-link" />
              </div>
            </router-link>
          </li>
          <li class="dataService-bottom-card-li">
            <router-link to="/dataServices/customizePlan">
              <div class="dataService-bottom-card-in positionRight">
                <div class="dataService-bottom-card-open">
                  <div class="dataService-card-open-li">
                    <div class="dataService-open-title">How It Works</div>
                    <ul class="dataService-open-text">
                      <li>
                        Complete the Brief Survey: Answer key questions about
                        your data scope, use cases, and technical needs.
                      </li>
                      <li>
                        Submit with One Click: Send your requirements to our
                        solutions team instantly.
                      </li>
                      <li>
                        Receive Your Matched Plan: We'll quickly analyze your
                        needs and propose the most suitable service package and
                        technical approach.
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="dataService-bottom-card-close">
                  <div class="dataService-bottom-card-icon">
                    <img :src="dsIcon5" />
                  </div>
                  <div class="dataService-bottom-card-title">
                    Customize Your Own Plan
                  </div>
                  <div class="dataService-bottom-card-text">
                    Tell us what you need. Complete our survey to get a tailored
                    data service plan that fits your requirements.
                  </div>
                </div>
                <img :src="dsIcon6" class="dataService-bottom-card-link" />
              </div>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="new-home-bottom" v-else>
        <div class="new-home-title">Bringing Global Business Into Focus</div>
        <div class="new-home-bottom-card">
          <div
            class="new-home-card-left"
            :class="this.$route.name == 'newsIndex' ? 'NewsBack' : 'RiskBack'"
          >
            <img :src="ellipseImg" />
            <div
              class="slider-box"
              @click="goPage('https://www.csibizinfo.com/?Form=Csi')"
            >
              <div class="slider-con">
                <div
                  class="slider-item"
                  v-for="(item, index) in textList"
                  :key="index"
                >
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>
          <div class="new-home-card-middle">
            <div
              class="new-home-middle-img"
              :style="{ backgroundImage: 'url(' + middleImg + ')' }"
            ></div>
            <div
              class="new-home-middle-text"
              @click="goPage('https://www.csibizinfo.com/')"
            >
              CSI, a data-driven research and IT firm, specializes in credit,
              risk, and big data. It offers digital tools to global investors
              and business professionals, leveraging advanced analytics and
              algorithms to provide fast, visual insights that facilitate
              smarter decision-making.
            </div>
          </div>
          <div class="new-home-card-right">
            <div class="new-home-right-img">
              <img :src="wechatImg" />
            </div>
            <div class="new-home-right-text">
              To quickly search, view, and obtain company information, you can
              also use the CSI App on your phone.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/views/newLayout/header.vue";
import SearchCon from "@/views/newLayout/searchCon.vue";
export default {
  components: { Header, SearchCon },
  data() {
    return {
      offest: 38,
      carouselList: [
        {
          img: require("@/assets/images/0-1home.jpg"),
        },
        {
          img: require("@/assets/images/0-3home.jpg"),
        },
        {
          img: require("@/assets/images/chuan.png"),
        },
        {
          img: require("@/assets/images/0-5home.jpg"),
        },
        {
          img: require("@/assets/images/0-4home.jpg"),
        },
      ],
      ellipseImg: require("@/assets/images/newPage/ellipse.png"),
      middleImg: require("@/assets/images/newPage/home-center.jpg"),
      wechatImg: require("@/assets/images/newPage/wechat.png"),
      initIndex: 3,
      textList: [
        {
          title: "Business Intelligence",
        },
        {
          title: "Company Identity Verification",
        },
        {
          title: "KYC Solutions",
        },
        {
          title: "Company Financial Analysis",
        },
        {
          title: "Credit Ratings",
        },
        {
          title: "Credit Reports",
        },
        {
          title: "ESG Ratings",
        },
        {
          title: "Vendor Screening",
        },
        {
          title: "Market Research",
        },
        {
          title: "Industry Analysis",
        },
        {
          title: "Business Analytics",
        },
        {
          title: "Import-Export Data",
        },
        {
          title: "Company News",
        },
        {
          title: "Sanctions",
        },
        {
          title: "Search Leads",
        },
        {
          title: "Business Intelligence",
        },
        {
          title: "Company Identity Verification",
        },
        {
          title: "KYC Solutions",
        },
        {
          title: "Company Financial Analysis",
        },
        {
          title: "Credit Ratings",
        },
        {
          title: "Credit Reports",
        },
        {
          title: "ESG Ratings",
        },
        {
          title: "Vendor Screening",
        },
        {
          title: "Market Research",
        },
        {
          title: "Industry Analysis",
        },
        {
          title: "Business Analytics",
        },
        {
          title: "Import-Export Data",
        },
        {
          title: "Company News",
        },
        {
          title: "Sanctions",
        },
        {
          title: "Search Leads",
        },
      ],
      dsIcon1: require("@/assets/images/dataserviceIndex_1.svg"),
      dsIcon2: require("@/assets/images/dataserviceIndex_2.svg"),
      dsIcon3: require("@/assets/images/dataserviceIndex_3.svg"),
      dsIcon4: require("@/assets/images/dataserviceIndex_4.svg"),
      dsIcon5: require("@/assets/images/dataserviceIndex_5.svg"),
      dsIcon6: require("@/assets/images/dataserviceIndex_6.svg"),
      dsIcon7: require("@/assets/images/dataserviceIndex_7.png"),
    };
  },
  methods: {
    goPage(value) {
      window.open(value, "_blank");
    },
    scrollInit() {
      if (document.body.clientWidth >= 1510) {
        this.offest = 38;
      } else {
        this.offest = 22;
      }
      const body = document.querySelector(".slider-box");
      if (body) {
        const bodyRect = body.getBoundingClientRect();

        const bodyCenterY = bodyRect.top + bodyRect.height / 2;
        document.querySelectorAll(".slider-item").forEach((li) => {
          const liRect = li.getBoundingClientRect();
          const liCenterY = liRect.top + liRect.height / 2 + this.offest;

          if (Math.abs(bodyCenterY - liCenterY) < liRect.height / 2) {
            li.classList.add("active");
          } else {
            li.classList.remove("active");
          }
        });
      }
    },
  },
  mounted() {
    console.log(this.$route);

    setInterval(this.scrollInit, 100);
  },
  beforeDestroy() {
    clearInterval(this.scrollInit);
  },
};
</script>
<style scoped>
.new-home-con {
  flex: 1;
  position: relative;
}

.new-home-con .el-carousel {
  height: 100%;
}

.new-home-con >>> .el-carousel__container {
  height: 100%;
}

.new-home-con >>> .el-carousel__item {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.new-home-con >>> .el-carousel__indicators--horizontal {
  display: flex;
  align-items: center;
  height: 8px;
  bottom: 3%;
}

.new-home-con >>> .el-carousel__indicator {
  padding: 0;
}

.new-home-con >>> .el-carousel__indicator:not(:last-child) {
  margin-right: 6px;
}

.new-home-con >>> .el-carousel__button {
  width: 8px;
  height: 8px;
  opacity: 1;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.51);
}

.new-home-con >>> .el-carousel__indicator.is-active .el-carousel__button {
  background: rgba(255, 255, 255, 1);
}

.new-home-con .new-home-wrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100vh - 7vh);
  z-index: 2;
}

.new-home-search-text {
  font-weight: 400;
  font-size: 20px;
  color: #ffffff;
  line-height: 30px;
  text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.8);
  text-align: center;
}

.dataServiceIndex-search-text {
  border-radius: 15px;
  display: inline-block;
  font-size: 20px;
  padding: 0 10px 0 0;
  font-family: Arial;
}

.dataServiceIndex-search-text .point-num {
  color: #ff4646;
  font-family: Arial;
}

.dataServiceIndex-search-text .earth-icon {
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: inline-block;
}

.dataServiceIndex-search-text .earth-icon img {
  height: 18px;
  width: auto;
  vertical-align: sub;
}

.new-home-bottom {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 82.709%;
}

.new-home-bottom.dataService-home-bottom {
  width: 100%;
}

.new-home-title {
  width: calc(100% - 40px);
  height: 88px;
  margin: 0 auto;
  line-height: 88px;
  padding-left: 20px;
  font-weight: 400;
  font-size: 34px;
  color: #ffffff;
  text-shadow: 0px 2px 2px rgba(6, 59, 64, 0.5);
  background: rgba(105, 128, 146, 0.45);
  border-radius: 6px;
  backdrop-filter: blur(8px);
}

.new-home-bottom-card {
  display: flex;
  height: 352px;
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
}

.new-home-card-left,
.new-home-card-middle {
  flex: 1;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
}

.new-home-card-left {
  position: relative;
  padding-left: 50px;
  background: #1290c9;
}

.new-home-card-left img {
  position: absolute;
  top: 110px;
  left: 14px;
  width: 22px;
  height: 16px;
}

.new-home-card-left .slider-box {
  position: relative;
  height: 100%;
  overflow: hidden;
}

.new-home-card-left .slider-con {
  display: flex;
  flex-direction: column;
  /* 内容排列为竖直方向 */
  padding-top: 14px;
  animation: scrollTop 25s linear infinite;
  will-change: transform;
}
/* 数据服务 样式 开始*/
.dataService-bottom-card {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 20px;
}

.dataService-bottom-card-li {
  width: 300px;
  height: 352px;
  position: relative;
  /* margin-right: 22px; */
}

/* .dataService-bottom-card-li:last-of-type{
  margin-right: 0;
} */
.dataService-bottom-card-in {
  width: 300px;
  box-sizing: border-box;
  height: 352px;
  background: linear-gradient(
    136deg,
    rgba(22, 197, 216, 0.1) 0%,
    rgba(3, 44, 61, 0.52) 100%
  );
  border-radius: 12px;
  border: 3px solid transparent;
  background: url("../../assets/images/ds_border.png") no-repeat center/ 100%
    100%;
  backdrop-filter: blur(6px);
  display: flex;
  justify-content: start;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  /* transition: all .1s; */
}

.dataService-bottom-card-in.positionRight {
  right: 0;
  left: auto;
}

.dataService-bottom-card-link {
  position: absolute;
  right: 20px;
  bottom: 20px;
  width: 40px;
  height: 40px;
  cursor: pointer;
}

.dataService-bottom-card-close {
  width: 294px;
}

.dataService-bottom-card-open {
  width: 0;
  padding: 36px 36px 36px 65px;
  display: none;
}

.dataService-bottom-card-in:hover {
  width: auto;
  z-index: 2;
  background: linear-gradient(
    136deg,
    #b98b7317 0.22%,
    rgba(3, 44, 61, 0.52) 100%
  );
  border-radius: 14px;
  border: 3px solid #b98b73;
  backdrop-filter: blur(6px);
}

.dataService-bottom-card-in:hover .dataService-bottom-card-open {
  display: block;
  width: 644px;
}

.dataService-bottom-card-icon {
  width: 44px;
  height: 44px;
  margin: 40px auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dataService-bottom-card-title {
  font-family: Arial, Arial;
  font-weight: bold;
  font-size: 20px;
  color: #ffffff;
  line-height: 26px;
  text-align: center;
  font-style: normal;
  margin-bottom: 18px;
}

.dataService-bottom-card-text {
  padding: 0 20px 0 34px;
  font-family: Arial;
  font-size: 18px;
  color: #ffffff;
  line-height: 28px;
  text-align: left;
  font-style: normal;
}

.dataService-card-open-li {
  margin-bottom: 30px;
}

.dataService-open-title {
  color: #b98b73;
  font-size: 18px;
  line-height: 28px;
  font-family: Arial Bold;
  font-weight: bold;
}

.dataService-open-text {
  color: #fff;
  font-size: 18px;
  line-height: 28px;
  font-family: Arial Bold;
  font-weight: bold;
}

.dataService-open-text > li::before {
  content: "";
  display: inline-block;
  width: 6px;
  height: 6px;
  background: #fff;
  vertical-align: middle;
  margin-right: 10px;
}
/* 数据服务 样式 结束*/
@keyframes scrollTop {
  0% {
    transform: translateY(0);
    /* 初始位置 */
  }

  100% {
    transform: translateY(-47%);
  }
}

.new-home-card-left .slider-item {
  display: flex;
  align-items: center;
  height: 28px;
  line-height: 28px;
  font-weight: bold;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.4);
  transition: 0.5s ease-in-out !important;
  cursor: pointer;
}

.new-home-card-left .slider-item.active {
  font-size: 24px;
  color: #ffffff;
}

.new-home-card-left .slider-item:not(:last-child) {
  margin-bottom: 2px;
}

.new-home-card-middle {
  position: relative;
  margin: 0 14px;
  background-position: left center;
  background-size: cover;
  overflow: hidden;
}

.new-home-middle-img {
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate3d(-42%, 0%, 0);
  max-width: none;
  width: 703px;
  height: 399px;
  background-position: center center;
  background-size: cover;
  /* will-change: transform; */
  animation: scrollImg 12s linear infinite alternate;
}

@keyframes scrollImg {
  0% {
    transform: translate3d(-42%, 0%, 0);
  }

  50% {
    transform: translate3d(-50%, 0%, 0);
  }

  100% {
    transform: translate3d(-58%, 0%, 0);
  }
}

.new-home-middle-text {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 30px 20px;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 22px;
  text-align: justify;
  cursor: pointer;
}

.new-home-middle-text:hover {
  text-decoration: underline;
}

.new-home-card-right {
  width: 300px;
  padding: 40px 10px 0 10px;
  background: #f5f5f5;
  border-radius: 12px;
}

.new-home-right-img {
  width: 120px;
  height: 120px;
  padding: 3px;
  margin: 0 auto 16px auto;
  background: #ffffff;
}

.new-home-right-text {
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  text-align: center;
}

/* 数据服务 */
@media (max-width: 1920px) {
  .new-home-search-text {
    font-size: 14px;
    line-height: 20px;
  }

  .new-home-bottom {
    width: 1300px;
  }

  .new-home-title {
    width: calc(100% - 32px);
    height: 70px;
    line-height: 70px;
    padding-left: 16px;
    font-size: 28px;
    border-radius: 5px;
  }

  .new-home-bottom-card {
    height: 282px;
    padding: 16px;
    border-radius: 10px;
  }

  .new-home-card-left,
  .new-home-card-middle {
    border-radius: 10px;
  }

  .new-home-card-left {
    padding-left: 40px;
  }

  .new-home-card-left img {
    top: 80px;
    left: 11px;
    width: 18px;
    height: 14px;
  }

  .new-home-card-left .slider-con {
    padding-top: 11px;
  }

  .new-home-card-left .slider-item {
    height: 24px;
    line-height: 24px;
    font-size: 14px;
  }

  .new-home-card-left .slider-item.active {
    font-size: 20px;
  }

  .new-home-card-middle {
    margin: 0 12px;
  }

  .new-home-middle-img {
    width: 562px;
    height: 320px;
  }

  .new-home-middle-text {
    padding: 24px 16px;
    font-size: 14px;
    line-height: 18px;
  }

  .new-home-card-right {
    width: 240px;
    padding: 32px 8px 0 8px;
    border-radius: 10px;
  }

  .new-home-right-img {
    width: 96px;
    height: 96px;
  }

  .new-home-right-text {
    font-size: 14px;
    line-height: 18px;
  }
  /* 数据服务 样式 开始*/
  .dataService-bottom-card-li {
    width: 270px;
    height: 330px;
  }

  .dataService-bottom-card-in {
    width: 270px;
    height: 330px;
  }

  .dataService-bottom-card-close {
    width: 264px;
  }

  .dataService-bottom-card-icon {
    width: 36px;
    height: 36px;
    margin: 30px auto 16px;
  }

  .dataService-bottom-card-title {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .dataService-bottom-card-text {
    font-size: 16px;
    line-height: 26px;
  }

  .dataService-bottom-card-link {
    width: 34px;
    height: 34px;
  }

/* .dataService-bottom-card-open{
    padding: 20px 20px 20px 25px;
  } */
.dataService-card-open-li {
    margin-bottom: 20px;
  }

  .dataService-open-title {
    font-size: 16px;
    line-height: 24px;
  }

  .dataService-open-text {
    font-size: 16px;
    line-height: 26px;
  }

  .dataService-bottom-card-in:hover .dataService-bottom-card-open {
    width: 580px;
  }
  /* 数据服务 样式 结束 */
  
}

.u070db_3 {
  background: url("../../assets/images/0-1home.jpg") no-repeat;
}

.u070db_4 {
  background: url("../../assets/images/0-4Risk.jpg") no-repeat;
}

.u070db_5 {
  background: url("../../assets/images/0-4home.jpg") no-repeat;
}

.u070db_6 {
  background: url("../../assets/images/0-6home.jpg") no-repeat;
}

.u070db_6::before {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.25);
}

.NewsBack {
  background-color: #3ebb72 !important;
}

.RiskBack {
  background-color: #f9722c !important;
}

@media screen and (max-width: 1439px) {
  .new-home-bottom {
    width: 1100px;
  }

  .new-home-title {
    width: calc(100% - 28px);
    height: 60px;
    line-height: 60px;
    padding-left: 14px;
    font-size: 24px;
    border-radius: 4px;
  }

  .new-home-bottom-card {
    height: 246px;
    padding: 14px;
    border-radius: 8px;
  }

  .new-home-card-left,
  .new-home-card-middle {
    border-radius: 8px;
  }

  .new-home-card-left {
    padding-left: 35px;
  }

  .new-home-card-left img {
    top: 78px;
    left: 10px;
    width: 16px;
    height: 12px;
  }

  .new-home-card-left .slider-con {
    padding-top: 10px;
  }

  .new-home-card-left .slider-item {
    height: 20px;
    line-height: 20px;
    font-size: 12px;
  }

  .new-home-card-left .slider-item.active {
    font-size: 16px;
  }

  .new-home-card-middle {
    margin: 0 10px;
  }

  .new-home-middle-img {
    width: 492px;
    height: 280px;
  }

  .new-home-middle-text {
    padding: 20px 14px;
    font-size: 12px;
    line-height: 16px;
  }

  .new-home-card-right {
    width: 210px;
    padding: 28px 10px 0 7px;
    border-radius: 8px;
  }

  .new-home-right-img {
    width: 84px;
    height: 84px;
  }

  .new-home-right-text {
    font-size: 12px;
    line-height: 16px;
  }
  /* 数据服务 样式 开始*/
  .dataService-bottom-card-li {
    width: 200px;
    height: 330px;
  }

  .dataService-bottom-card-in {
    width: 200px;
    height: 330px;
  }

  .dataService-bottom-card-close {
    width: 194px;
  }

  .dataService-bottom-card-icon {
    width: 24px;
    height: 24px;
    margin: 20px auto 10px;
  }

  .dataService-bottom-card-title {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .dataService-bottom-card-text {
    font-size: 14px;
    line-height: 24px;
    padding: 0 10px 0 17px;
  }

  .dataService-bottom-card-link {
    width: 30px;
    height: 30px;
  }

  .dataService-bottom-card-open {
    padding: 20px 20px 20px 25px;
  }

  .dataService-card-open-li {
    margin-bottom: 12px;
  }

  .dataService-open-title {
    font-size: 16px;
    line-height: 24px;
  }

  .dataService-open-text {
    font-size: 14px;
    line-height: 22px;
  }

  .dataService-bottom-card-in:hover .dataService-bottom-card-open {
    width: 440px;
  }

  .dataServiceIndex-search-text .earth-icon {
    width: 20px;
    height: 20px;
  }

  .dataServiceIndex-search-text {
    font-size: 14px;
  }

  .dataServiceIndex-search-text .earth-icon img {
    height: 14px;
    vertical-align: text-top;
  }
  /* 数据服务 样式 结束*/
}
</style>
